module.exports = __webpack_public_path__ + "img/1521664040.43dd896c.jpg";